(() => {
  const root = document.querySelector('.main-product-hero');
  if (!root) return;

  const config = root.querySelector('[data-mph-config]');
  const summary = root.querySelector('[data-mph-summary]');
  const checklist = root.querySelector('[data-mph-checklist]');
  const totalEl = root.querySelector('[data-mph-total]');
  const adaptInput = root.querySelector('[data-mph-adapt]');
  const atcButtons = root.querySelectorAll('.main-product-hero__atc, .product-form__sticky-submit');
  const priceRoot = root.querySelector('[id^="price-"]');
  const guardEl = root.querySelector('[data-mph-guard]');
  const adaptWrap = root.querySelector('[data-mph-adapt-wrap]');

  let adaptBound = false;
  const adaptSourceInputs = new WeakSet();
  const cloneControlState = new Map();

  const readVisuals = () => {
    try {
      return JSON.parse(root.querySelector('[data-mph-visuals]')?.textContent || '{}');
    } catch (error) {
      console.warn('[main-product-hero] Invalid option visuals JSON', error);
      return {};
    }
  };
  const visuals = readVisuals();

  // Figma 450:14794 "Check"
  const checkIcon =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M14.3535 4.85403L6.35354 12.854C6.3071 12.9005 6.25196 12.9374 6.19126 12.9626C6.13056 12.9877 6.0655 13.0007 5.99979 13.0007C5.93408 13.0007 5.86902 12.9877 5.80832 12.9626C5.74762 12.9374 5.69248 12.9005 5.64604 12.854L2.14604 9.35403C2.05222 9.26021 1.99951 9.13296 1.99951 9.00028C1.99951 8.8676 2.05222 8.74035 2.14604 8.64653C2.23986 8.55271 2.36711 8.5 2.49979 8.5C2.63247 8.5 2.75972 8.55271 2.85354 8.64653L5.99979 11.7934L13.646 4.14653C13.7399 4.05271 13.8671 4 13.9998 4C14.1325 4 14.2597 4.05271 14.3535 4.14653C14.4474 4.24035 14.5001 4.3676 14.5001 4.50028C14.5001 4.63296 14.4474 4.76021 14.3535 4.85403Z" fill="currentColor"/></svg>';

  // Figma 450:18534 "Info" — replaces the app's question-mark tooltip glyph in builder fields.
  const infoIcon =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M8 1.5C6.71442 1.5 5.45771 1.88122 4.38879 2.59545C3.31987 3.30968 2.48675 4.32484 1.99478 5.51256C1.50281 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49476 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73191 14.3751C7.99279 14.6259 9.29972 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM8 13.5C6.9122 13.5 5.84883 13.1774 4.94436 12.5731C4.03989 11.9687 3.33494 11.1098 2.91866 10.1048C2.50238 9.09977 2.39346 7.9939 2.60568 6.927C2.8179 5.86011 3.34172 4.8801 4.11091 4.11091C4.8801 3.34172 5.86011 2.8179 6.927 2.60568C7.9939 2.39346 9.09977 2.50238 10.1048 2.91866C11.1098 3.33494 11.9687 4.03989 12.5731 4.94436C13.1774 5.84883 13.5 6.9122 13.5 8C13.4983 9.45818 12.9184 10.8562 11.8873 11.8873C10.8562 12.9184 9.45818 13.4983 8 13.5ZM9 11C9 11.1326 8.94732 11.2598 8.85355 11.3536C8.75979 11.4473 8.63261 11.5 8.5 11.5C8.23478 11.5 7.98043 11.3946 7.79289 11.2071C7.60536 11.0196 7.5 10.7652 7.5 10.5V8C7.36739 8 7.24021 7.94732 7.14645 7.85355C7.05268 7.75979 7 7.63261 7 7.5C7 7.36739 7.05268 7.24021 7.14645 7.14645C7.24021 7.05268 7.36739 7 7.5 7C7.76522 7 8.01957 7.10536 8.20711 7.29289C8.39464 7.48043 8.5 7.73478 8.5 8V10.5C8.63261 10.5 8.75979 10.5527 8.85355 10.6464C8.94732 10.7402 9 10.8674 9 11ZM7 5.25C7 5.10166 7.04399 4.95666 7.1264 4.83332C7.20881 4.70999 7.32594 4.61386 7.46299 4.55709C7.60003 4.50032 7.75083 4.48547 7.89632 4.51441C8.0418 4.54335 8.17544 4.61478 8.28033 4.71967C8.38522 4.82456 8.45665 4.9582 8.48559 5.10368C8.51453 5.24917 8.49967 5.39997 8.44291 5.53701C8.38614 5.67406 8.29001 5.79119 8.16668 5.8736C8.04334 5.95601 7.89834 6 7.75 6C7.55109 6 7.36032 5.92098 7.21967 5.78033C7.07902 5.63968 7 5.44891 7 5.25Z" fill="currentColor"/></svg>';

  const normalizeLabel = (label) =>
    String(label || '')
      .replace(/[:：]\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim();

  const escapeHtml = (value) =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const readPriceText = () => {
    if (!priceRoot) return totalEl?.textContent?.trim() || '';
    const sale = priceRoot.querySelector('.price-item--sale');
    const regular = priceRoot.querySelector('.price__regular .price-item--regular, .price-item--regular');
    const onSale = priceRoot.querySelector('.price--on-sale');
    const node = onSale && sale ? sale : regular || sale;
    return node?.textContent?.trim() || totalEl?.textContent?.trim() || '';
  };

  const fieldLabel = (field) => {
    const heading = field.querySelector('.tcustomizer-field__heading');
    const title = heading?.querySelector(':scope > span:not([class])');
    if (title?.textContent) return normalizeLabel(title.textContent).replace(/\*+$/, '').trim();

    const fallback = field.querySelector('.tcustomizer-option__title, legend, .form__label');
    return normalizeLabel(fallback?.textContent || field.getAttribute('data-title') || '').replace(/\*+$/, '').trim();
  };

  // Figma 450:14791: summary labels and order (left column, then right column).
  const summaryLabel = (label) => {
    const key = label.toLowerCase();
    if (key.includes('prescription lens')) return 'Prescription';
    if (key.includes('frame size')) return 'Frame Size';
    if (key.includes('working distance')) return 'Working Distance';
    if (key.includes('back pain')) return 'Back Pain';
    if (/loupe shape|frame design|frame style|^style$/.test(key)) return 'Frame Style';
    if (/^color$|loupe colou?r/.test(key)) return 'Loupe Color';
    if (/colou?r frames|frame colou?r/.test(key)) return 'Frame Color';
    return label;
  };

  const SUMMARY_ORDER = ['loupe color', 'frame style', 'frame color', 'frame size', 'magnification', 'working distance', 'back pain', 'prescription', 'personalized engraving'];
  const summaryRank = (label) => {
    const index = SUMMARY_ORDER.indexOf(label.toLowerCase());
    return index < 0 ? SUMMARY_ORDER.length : index;
  };

  const classifyQikifyLabel = (label, field) => {
    const key = normalizeLabel(label).toLowerCase();
    const typeClass = String(field?.className || '').toLowerCase();
    if (/singlecheckbox|single-checkbox/.test(typeClass)) return 'adapt';
    if (!key) return 'skip';
    if (/adaptation|single checkbox/.test(key)) return 'adapt';
    // Figma 450:18688: Frame Size leads the style step, Frame Color follows the native loupe options.
    if (/frame\s*size/.test(key)) return 'style-lead';
    if (/frame\s*colou?r/.test(key)) return 'style';
    if (/fast[\s-]*track|fast[\s-]*build/.test(key)) return 'fast';
    return 'prescription';
  };

  const findTcForm = () =>
    config?.querySelector('.tcustomizer-customization-form, [id^="tcustomizer-form-container"] form, [id^="tcustomizer-form-container"]') ||
    root.querySelector('.tcustomizer-customization-form, [id^="tcustomizer-form-container"] form, [id^="tcustomizer-form-container"]');

  const findTcFields = (host) => {
    if (!host) return [];
    // Only real TEPO field roots — never headings/options that also contain "tcustomizer-field" in their class.
    return [...host.querySelectorAll('.tcustomizer-field')].filter(
      (node) =>
        node.classList.contains('tcustomizer-field') &&
        !node.closest('[data-mph-qikify-slot]') &&
        !node.dataset.mphClone
    );
  };

  const uniqueId = (prefix) => `${prefix}-${Math.random().toString(36).slice(2, 9)}`;

  const remapCloneIds = (clone) => {
    clone.querySelectorAll('[id]').forEach((el) => {
      const oldId = el.id;
      if (!oldId) return;
      const newId = uniqueId('mph-clone');
      el.id = newId;
      clone.querySelectorAll('label[for]').forEach((label) => {
        if (label.getAttribute('for') === oldId) {
          label.setAttribute('for', newId);
        }
      });
    });
  };

  // Clones resolve their source by the app's stable field id on every event: the app re-renders fields
  // (for example after its own validation), which detaches any cached node.
  const fieldToken = (field) => [...field.classList].find((cls) => /^tcustomizer-field-\d+/.test(cls)) || '';

  const sourceOf = (cloneField) => {
    const id = cloneField.dataset.mphSourceId;
    const byId = id && document.getElementById(id);
    if (byId) return byId;
    const token = fieldToken(cloneField);
    if (!token) return null;
    return (
      [...document.querySelectorAll(`.tcustomizer-field.${CSS.escape(token)}`)].find(
        (node) => !node.classList.contains('mph-field--clone') && (node.classList.contains('mph-field--sourced') || node.id)
      ) || null
    );
  };

  const controlsOf = (field) =>
    [...field.querySelectorAll('input, select, textarea')].filter((el) => !el.classList.contains('tcustomizer-quantity-input'));

  const matchSourceControl = (cloneCtrl, sourceField) => {
    const sourceControls = controlsOf(sourceField);
    if (cloneCtrl.type === 'radio' || cloneCtrl.type === 'checkbox') {
      return sourceControls.find((ctrl) => ctrl.type === cloneCtrl.type && String(ctrl.value) === String(cloneCtrl.value)) || null;
    }
    return (
      sourceControls.find((ctrl) => ctrl.tagName === cloneCtrl.tagName && ctrl.type === cloneCtrl.type) ||
      null
    );
  };

  // Qikify controls are framework-managed. Use the native prototype setter so its input handler
  // observes the new value before the widget re-renders the source field.
  const setNativeControlValue = (control, value) => {
    const prototype =
      control instanceof HTMLTextAreaElement
        ? HTMLTextAreaElement.prototype
        : control instanceof HTMLSelectElement
          ? HTMLSelectElement.prototype
          : HTMLInputElement.prototype;
    const setter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;
    if (setter) {
      setter.call(control, value);
    } else {
      control.value = value;
    }
  };

  const syncControlToSource = (cloneCtrl, sourceCtrl) => {
    if (!cloneCtrl || !sourceCtrl || cloneCtrl.type === 'file') return;
    if (cloneCtrl.type === 'radio' || cloneCtrl.type === 'checkbox') {
      // Qikify binds some option state (notably custom dropdowns) on the source label rather than
      // the hidden input. Click that real app control so its model and validation update together.
      if (sourceCtrl.checked !== cloneCtrl.checked && !sourceCtrl.disabled) {
        const sourceField = sourceCtrl.closest('.tcustomizer-field');
        const sourceLabel = sourceCtrl.id
          ? sourceField?.querySelector(`label[for="${CSS.escape(sourceCtrl.id)}"]`)
          : null;
        (sourceLabel || sourceCtrl).click();
      }
      return;
    }
    setNativeControlValue(sourceCtrl, cloneCtrl.value);
    sourceCtrl.dispatchEvent(new Event('input', { bubbles: true }));
    sourceCtrl.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const syncSourceToClone = (sourceField, cloneField) => {
    const cloneControls = controlsOf(cloneField);
    controlsOf(sourceField).forEach((sourceCtrl, index) => {
      const cloneCtrl = cloneControls[index];
      if (!cloneCtrl || sourceCtrl.type === 'file') return;
      if (sourceCtrl.type === 'radio' || sourceCtrl.type === 'checkbox') {
        cloneCtrl.checked = sourceCtrl.checked;
      } else {
        const stateKey = `${cloneField.dataset.mphSourceId}:${index}`;
        cloneCtrl.value = cloneControlState.has(stateKey) ? cloneControlState.get(stateKey) : sourceCtrl.value;
      }
    });
  };

  const pushCloneToSource = (cloneField, sourceField) => {
    const source = sourceField || sourceOf(cloneField);
    if (!source) return;
    controlsOf(cloneField).forEach((cloneCtrl, index) => {
      const sourceCtrl = matchSourceControl(cloneCtrl, source) || controlsOf(source)[index];
      if (!sourceCtrl || cloneCtrl.type === 'file') return;
      if (cloneCtrl.type === 'radio') {
        if (cloneCtrl.checked) syncControlToSource(cloneCtrl, sourceCtrl);
        return;
      }
      if (cloneCtrl.type === 'checkbox') {
        if (cloneCtrl.checked !== sourceCtrl.checked) syncControlToSource(cloneCtrl, sourceCtrl);
        return;
      }
      if (String(cloneCtrl.value || '') !== String(sourceCtrl.value || '')) {
        syncControlToSource(cloneCtrl, sourceCtrl);
      }
    });
  };

  // Qikify can mark a checkbox group required while leaving only one option enabled
  // (EVO XL Fast-Track: Yes is sold-out/disabled, No is the only valid answer).
  const settleRequiredOnlyChoices = () => {
    if (!config) return;
    config.querySelectorAll('.mph-field--clone').forEach((field) => {
      if (!field.querySelector('.tcustomizer-field__heading .tcustomizer-asterisk')) return;
      const boxes = controlsOf(field).filter((el) => el.type === 'checkbox');
      if (boxes.length < 2) return;
      const enabled = boxes.filter((el) => !el.disabled);
      if (enabled.length !== 1 || enabled[0].checked) return;
      enabled[0].checked = true;
      enabled[0].dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const qikifyFormInstance = () =>
    root.querySelector('.tcustomizer-customization-form')?.__vueParentComponent || null;

  const qikifyModel = () => {
    const inst = qikifyFormInstance();
    const model = inst?.props?.modelValue || inst?.parent?.props?.modelValue;
    if (!model || typeof model !== 'object') return null;
    if ('value' in model && model.value && typeof model.value === 'object' && !Array.isArray(model.value)) {
      return model.value;
    }
    return model;
  };

  const qikifyFieldId = (field) => {
    const match = fieldToken(field).match(/^tcustomizer-field-(\d+)/);
    return match ? Number(match[1]) : null;
  };

  const qikifyFieldMeta = (field) => {
    const id = qikifyFieldId(field);
    const inst = qikifyFormInstance();
    const list = inst?.props?.fields;
    const raw = list && typeof list === 'object' && 'value' in list && !Array.isArray(list) ? list.value : list;
    const vueField = Array.isArray(raw) ? raw.find((entry) => Number(entry.id) === id) : null;
    const schema = (window._TC?.manualOption?.fields || []).find((entry) => Number(entry.id) === id);
    return {
      id,
      key: vueField?.label || schema?.title || schema?.label || fieldLabel(field),
      type: vueField?.type || schema?.type || '',
    };
  };

  const cloneModelValue = (field) => {
    const meta = qikifyFieldMeta(field);
    const chosen = controlsOf(field).filter(
      (el) => (el.type === 'radio' || el.type === 'checkbox') && el.checked && !el.disabled
    );
    if (meta.type === 'SingleCheckbox' || field.classList.contains('tcustomizer-field--SingleCheckbox')) {
      return chosen.length ? 'Checked' : '';
    }
    if (meta.type === 'Checkbox' || field.classList.contains('tcustomizer-field--Checkbox')) {
      return chosen.map((el) => el.value);
    }
    if (chosen.length) return chosen[0].value;
    const text = controlsOf(field).find((el) =>
      el.matches('textarea, select, input[type="text"], input[type="number"], input[type="email"], input:not([type])')
    );
    return text ? String(text.value || '') : '';
  };

  const writeQikifyModel = (key, value) => {
    const model = qikifyModel();
    if (!model || !key) return;
    model[key] = value;
  };

  // Hidden source nodes are clipped and pointer-events:none, so Qikify's Vue model never
  // sees clone clicks. Validation reads that model (Frame Color* on XL), not the DOM.
  const pushCloneToQikifyModel = (cloneField) => {
    const meta = qikifyFieldMeta(cloneField);
    if (!meta.key) return;
    const value = cloneModelValue(cloneField);
    const filled = Array.isArray(value) ? value.length > 0 : Boolean(String(value || '').trim());
    if (filled) writeQikifyModel(meta.key, value);
  };

  const flushClonesToSources = () => {
    if (!config) return;
    settleRequiredOnlyChoices();
    config.querySelectorAll('.mph-field--clone').forEach((clone) => {
      pushCloneToSource(clone);
      pushCloneToQikifyModel(clone);
    });
    bindAdaptationSync();
    if (adaptInput?.checked) {
      const adaptSource =
        root.querySelector('.mph-field--adapt-source') || root.querySelector('.tcustomizer-field--SingleCheckbox');
      const key = adaptSource ? qikifyFieldMeta(adaptSource).key : 'Disclaimer';
      writeQikifyModel(key || 'Disclaimer', 'Checked');
    }
  };

  const wireCloneSync = (cloneField) => {
    const onEdit = (event) => {
      const cloneCtrl = event.target;
      if (!cloneCtrl?.matches?.('input, select, textarea')) return;
      if (event.type === 'input' && (cloneCtrl.type === 'radio' || cloneCtrl.type === 'checkbox')) return;
      const sourceField = sourceOf(cloneField);
      if (!sourceField) return;
      const cloneControls = controlsOf(cloneField);
      const index = cloneControls.indexOf(cloneCtrl);
      if (index < 0) return;
      if (cloneCtrl.type !== 'radio' && cloneCtrl.type !== 'checkbox' && cloneCtrl.type !== 'file') {
        cloneControlState.set(`${cloneField.dataset.mphSourceId}:${index}`, cloneCtrl.value);
      }
      if (cloneCtrl.type === 'radio' && cloneCtrl.checked) {
        cloneControls.forEach((other) => {
          if (other !== cloneCtrl && other.type === 'radio' && other.name === cloneCtrl.name) other.checked = false;
        });
      }
      if (cloneCtrl.type === 'checkbox' && cloneCtrl.checked) {
        cloneControls.forEach((other) => {
          if (other !== cloneCtrl && other.type === 'checkbox') other.checked = false;
        });
      }
      syncControlToSource(cloneCtrl, matchSourceControl(cloneCtrl, sourceField) || controlsOf(sourceField)[index]);
      pushCloneToQikifyModel(cloneField);
      renderChecklist();
    };
    cloneField.addEventListener('change', onEdit);
    cloneField.addEventListener('input', onEdit);
  };

  const handleize = (value) =>
    String(value || '')
      .replace(/\*/g, '')
      .split('(')[0]
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const styleFor = (label) => {
    const key = handleize(label);
    return (visuals.styles || []).find((entry) => (entry.names || []).some((name) => handleize(name) === key)) || null;
  };

  const imageFor = (label, value, style) => {
    const optionKey = handleize(label);
    const valueKey = handleize(value);
    const custom = (visuals.values || []).find(
      (entry) =>
        handleize(entry.value) === valueKey &&
        (!entry.option || handleize(entry.option) === optionKey || handleize(entry.option) === handleize(style?.label))
    );
    if (custom?.image || custom?.color) return { image: custom.image, color: custom.color };
    const art = style?.art && style.art !== 'none' ? visuals.art?.[style.art]?.[valueKey] : '';
    return art ? { image: art } : null;
  };

  // App fields are clones we own: restyle them to the builder contract without touching the hidden source.
  const applyFieldVisuals = (field) => {
    const label = fieldLabel(field);
    const style = styleFor(label);
    const headingText = field.querySelector('.tcustomizer-field__heading > span:not([class])');
    if (style?.label && headingText) headingText.textContent = style.label;

    field.querySelectorAll('.tcustomizer-tooltip__icon > svg').forEach((svg) => {
      svg.outerHTML = infoIcon;
    });

    if (!field.classList.contains('tcustomizer-field--RadioColor')) return;
    field.classList.add('mph-field--swatches');
    field.querySelectorAll('input.tcustomizer__btn-check').forEach((input) => {
      const swatch = input.id ? field.querySelector(`label[for="${CSS.escape(input.id)}"] .tcustomizer__image-content`) : null;
      if (!swatch) return;
      const visual = imageFor(label, input.value, style);
      if (visual?.image) {
        swatch.style.backgroundImage = `url("${visual.image}")`;
        swatch.classList.add('mph-swatch--image');
      } else if (visual?.color) {
        swatch.style.backgroundColor = visual.color;
      }
      const wrapper = swatch.closest('label');
      if (wrapper && !wrapper.getAttribute('aria-label')) wrapper.setAttribute('aria-label', input.value);
    });
  };

  const applyImplicitDefault = (cloneField) => {
    if (!/frame\s*size/i.test(fieldLabel(cloneField))) {
      syncChoiceVisuals(cloneField);
      if (fieldChosen(cloneField)) pushCloneToQikifyModel(cloneField);
      return;
    }
    const meta = qikifyFieldMeta(cloneField);
    const model = qikifyModel();
    const fromModel = model && meta.key ? model[meta.key] : '';
    const picked = fromModel || controlsOf(cloneField).find((el) => el.checked)?.value;
    const fallback = controlsOf(cloneField).find((el) => el.type === 'radio' && !el.disabled)?.value;
    const value = picked || fallback;
    if (!value) {
      syncChoiceVisuals(cloneField);
      return;
    }
    const control = controlsOf(cloneField).find((el) => String(el.value) === String(value));
    if (control) control.checked = true;
    syncChoiceVisuals(cloneField);
    pushCloneToSource(cloneField);
    pushCloneToQikifyModel(cloneField);
  };

  const placeField = (sourceField, requestedSlot) => {
    let slotName = requestedSlot;
    let slot = config?.querySelector(`[data-mph-qikify-slot="${slotName}"]`);
    if (!slot && slotName === 'style-lead') {
      slotName = 'style';
      slot = config?.querySelector('[data-mph-qikify-slot="style"]');
    }
    if (!slot) return false;

    const hasFile = Boolean(sourceField.querySelector('input[type="file"]'));
    if (hasFile) {
      const form =
        sourceField.closest('form') ||
        config?.querySelector('.tcustomizer-customization-form') ||
        root.querySelector('.tcustomizer-customization-form');
      if (form && !form.id) {
        form.id = uniqueId('mph-tc-form');
      }
      if (form?.id) {
        sourceField.querySelectorAll('input, select, textarea, button').forEach((el) => {
          el.setAttribute('form', form.id);
        });
      }
      sourceField.classList.add('mph-field--hosted');
      sourceField.dataset.mphHosted = slotName;
      applyFieldVisuals(sourceField);
      slot.appendChild(sourceField);
      return true;
    }

    const clone = sourceField.cloneNode(true);
    clone.dataset.mphClone = slotName;
    clone.dataset.mphSourceId = sourceField.id;
    clone.removeAttribute('id');
    clone.classList.add('mph-field--clone');
    remapCloneIds(clone);
    clone.querySelectorAll('[name]').forEach((el) => {
      el.setAttribute('data-mph-mirror-name', el.getAttribute('name'));
      el.removeAttribute('name');
    });
    const radioFields = clone.matches('.tcustomizer-field')
      ? [clone, ...clone.querySelectorAll('.tcustomizer-field')]
      : [...clone.querySelectorAll('.tcustomizer-field')];
    radioFields.forEach((field) => {
      const radios = [...field.querySelectorAll('input[type="radio"]')].filter(
        (input) => input.closest('.tcustomizer-field') === field
      );
      if (!radios.length) return;
      const groupName = uniqueId('mph-radio');
      radios.forEach((input) => {
        input.name = groupName;
      });
    });
    applyFieldVisuals(clone);
    slot.appendChild(clone);
    sourceField.classList.add('mph-field--sourced');
    sourceField.dataset.mphSourced = slotName;
    wireCloneSync(clone);
    syncSourceToClone(sourceField, clone);
    // Keep a real Qikify/Shopify default selected and marked. Only strip painted-active
    // on options that are not actually checked.
    clearCloneChoices(clone);
    applyImplicitDefault(clone);
    wireCloneWidgets(clone);
    return true;
  };

  const syncChoiceVisuals = (scope) => {
    if (!scope) return;
    scope.querySelectorAll('.tcustomizer__btn-check').forEach((control) => {
      if (!(control instanceof HTMLInputElement)) return;
      const label = control.id ? scope.querySelector(`label[for="${CSS.escape(control.id)}"]`) : null;
      label?.classList.toggle('tcustomizer-btn--active', control.checked);
    });
  };

  // Drop Qikify's painted-active state when the input is not actually checked. Keep real
  // defaults (Frame Size Small, native Style / Frame Color) selected and marked.
  const clearCloneChoices = (cloneField) => {
    cloneField.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => {
      if (input.checked) return;
      const label = input.id ? cloneField.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
      label?.classList.remove('tcustomizer-btn--active');
    });
    syncChoiceVisuals(cloneField);
  };

  const wireCloneWidgets = (clone) => {
    clone.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (input.type !== 'radio' && input.type !== 'checkbox') return;
      const group = input.closest('.tcustomizer-field') || clone;
      group.querySelectorAll('.tcustomizer__btn-check').forEach((control) => {
        if (control.type !== input.type || control.name && input.name && control.name !== input.name) return;
        const label = control.id ? group.querySelector(`label[for="${CSS.escape(control.id)}"]`) : null;
        label?.classList.toggle('tcustomizer-btn--active', control.checked);
      });
    });

    const dropdown = clone.querySelector('.tcustomizer__dropdown');
    if (!dropdown) return;
    const button = dropdown.querySelector('.tcustomizer__dropdown-button');
    const list = dropdown.querySelector('.tcustomizer__dropdown-list');
    if (!button || !list) return;

    button.tabIndex = 0;
    button.setAttribute('role', 'button');
    button.setAttribute('aria-expanded', 'false');

    const setDropdownOpen = (open) => {
      list.classList.toggle('active', open);
      button.classList.toggle('active', open);
      button.setAttribute('aria-expanded', String(open));
    };

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const willOpen = !list.classList.contains('active');
      root.querySelectorAll('.tcustomizer__dropdown-list.active').forEach((openList) => {
        if (openList === list) return;
        openList.classList.remove('active');
        const otherButton = openList.parentElement?.querySelector('.tcustomizer__dropdown-button');
        otherButton?.classList.remove('active');
        otherButton?.setAttribute('aria-expanded', 'false');
      });
      setDropdownOpen(willOpen);
    });

    button.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      button.click();
    });

    if (root.dataset.mphDropdownBound !== 'true') {
      root.dataset.mphDropdownBound = 'true';
      document.addEventListener('click', (event) => {
        root.querySelectorAll('.tcustomizer__dropdown-list.active').forEach((openList) => {
          const host = openList.closest('.tcustomizer__dropdown');
          if (host?.contains(event.target)) return;
          openList.classList.remove('active');
          const hostButton = host?.querySelector('.tcustomizer__dropdown-button');
          hostButton?.classList.remove('active');
          hostButton?.setAttribute('aria-expanded', 'false');
        });
      });
    }

    list.addEventListener('click', (event) => {
      const item = event.target.closest('.tcustomizer__dropdown-item');
      if (!item || !list.contains(item)) return;
      const input = item.querySelector('input[type="radio"], input[type="checkbox"]');
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const valueText = item.querySelector('.tcustomizer__dropdown-item-value')?.textContent?.replace(/\s+/g, ' ').trim();
      const label = button.querySelector('span');
      if (valueText && label) label.textContent = valueText;
      dropdown.classList.add('tcustomizer__dropdown--has-value');
      list.classList.remove('active');
      button.classList.remove('active');
      button.setAttribute('aria-expanded', 'false');
    });
  };

  const renumberSteps = () => {
    if (!config) return;
    let n = 1;
    config.querySelectorAll('[data-mph-step]').forEach((step) => {
      if (step.hidden || step.classList.contains('mph-step--empty')) return;
      const badge = step.querySelector('[data-mph-step-num]');
      if (badge) badge.textContent = String(n);
      n += 1;
    });
  };

  const hideEmptySlots = () => {
    if (!config) return;
    ['build', 'style', 'prescription', 'fast'].forEach((slotName) => {
      const step = config.querySelector(`[data-mph-step="${slotName}"]`);
      if (!step) return;
      const slot = step.querySelector(`[data-mph-qikify-slot="${slotName}"]`);
      const hasNative = Boolean(step.querySelector('[data-mph-native-option], fieldset, .product-form__input--dropdown'));
      const hasQikify = [...step.querySelectorAll('[data-mph-qikify-slot]')].some((node) => node.children.length > 0);

      if (slotName === 'build') {
        // Step 1 holds native option pickers only; never leave a dead accordion if it is empty.
        step.hidden = !hasNative;
        step.classList.toggle('mph-step--empty', step.hidden);
        if (step.hidden && step.open) step.open = false;
        return;
      }

      if (slotName === 'fast') {
        const hasFastTrack = [...(slot?.querySelectorAll('.tcustomizer-field__heading') || [])].some((heading) =>
          /fast[-\s]*track\s*build/i.test(heading.textContent || '')
        );
        step.hidden = !hasFastTrack;
        step.classList.toggle('mph-step--empty', step.hidden);
        if (step.hidden && step.open) step.open = false;
        return;
      }

      if (slotName === 'style') {
        step.hidden = !(hasNative || hasQikify);
        step.classList.toggle('mph-step--empty', step.hidden);
        return;
      }

      step.hidden = !hasQikify;
      step.classList.toggle('mph-step--empty', !hasQikify);
    });
    renumberSteps();
  };

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const panelOf = (details, selector) => details.querySelector(selector);

  let animSeq = 0;

  const releasePanel = (panel) => {
    if (!panel) return;
    panel.dataset.mphAnim = '';
    panel.style.height = '';
    panel.style.overflow = '';
    panel.style.transition = '';
  };

  // Measure with the panel open to its content. A collapsed step keeps height: 0,
  // and scrollHeight then reports that clipped box instead of the options.
  const measurePanel = (panel) => {
    const height = panel.style.height;
    const overflow = panel.style.overflow;
    const transition = panel.style.transition;
    panel.style.transition = 'none';
    panel.style.height = 'auto';
    panel.style.overflow = 'hidden';
    const next = panel.scrollHeight;
    panel.style.height = height;
    panel.style.overflow = overflow;
    panel.style.transition = transition;
    return next;
  };

  const settleStep = (details, open) => {
    details.open = open;
    details.classList.toggle('mph-step--open', open);
    releasePanel(panelOf(details, '.mph-step__body'));
  };

  const expandDetails = (details, selector) => {
    const panel = panelOf(details, selector);
    details.open = true;
    if (details.classList.contains('mph-step')) details.classList.add('mph-step--open');
    if (!panel || prefersReducedMotion()) {
      releasePanel(panel);
      return;
    }
    const token = String(++animSeq);
    panel.dataset.mphAnim = token;
    const end = measurePanel(panel);
    panel.style.overflow = 'hidden';
    panel.style.transition = 'none';
    panel.style.height = '0px';
    panel.getBoundingClientRect();
    panel.style.transition = 'height 0.35s ease';
    panel.style.height = `${end}px`;
    const done = (event) => {
      if (event.target !== panel || event.propertyName !== 'height') return;
      if (panel.dataset.mphAnim !== token || !details.open) return;
      panel.removeEventListener('transitionend', done);
      releasePanel(panel);
    };
    panel.addEventListener('transitionend', done);
  };

  const collapseDetails = (details, selector) => {
    const panel = panelOf(details, selector);
    if (!panel || !details.open || prefersReducedMotion()) {
      settleStep(details, false);
      return;
    }
    const token = String(++animSeq);
    panel.dataset.mphAnim = token;
    const start = measurePanel(panel);
    panel.style.overflow = 'hidden';
    panel.style.transition = 'none';
    panel.style.height = `${start}px`;
    panel.getBoundingClientRect();
    panel.style.transition = 'height 0.35s ease';
    panel.style.height = '0px';
    const done = (event) => {
      if (event.target !== panel || event.propertyName !== 'height') return;
      if (panel.dataset.mphAnim !== token) return;
      panel.removeEventListener('transitionend', done);
      details.open = false;
      details.classList.remove('mph-step--open');
      releasePanel(panel);
    };
    panel.addEventListener('transitionend', done);
  };

  const bindAnimatedDetails = (host, itemSelector, panelSelector, exclusive) => {
    if (!host || host.dataset.mphAnimBound === itemSelector) return;
    host.dataset.mphAnimBound = itemSelector;
    host.addEventListener('click', (event) => {
      const summary = event.target.closest('summary');
      if (!summary || !host.contains(summary)) return;
      const details = summary.parentElement;
      if (!(details instanceof HTMLDetailsElement) || !details.matches(itemSelector)) return;
      if (details.classList.contains('mph-step--locked')) {
        event.preventDefault();
        return;
      }
      if (prefersReducedMotion()) return;
      event.preventDefault();
      if (details.open) {
        collapseDetails(details, panelSelector);
        return;
      }
      if (exclusive) {
        host.querySelectorAll(itemSelector).forEach((other) => {
          if (other !== details && other.open) collapseDetails(other, panelSelector);
        });
      }
      expandDetails(details, panelSelector);
    });
  };

  const initExclusiveAccordion = () => {
    if (!config || config.dataset.mphAccordionBound === 'true') return;
    config.dataset.mphAccordionBound = 'true';

    config.addEventListener(
      'toggle',
      (event) => {
        const step = event.target;
        if (!(step instanceof HTMLDetailsElement) || !step.matches('[data-mph-step]')) return;
        step.classList.toggle('mph-step--open', step.open);
        if (step.classList.contains('mph-step--locked') && step.open) {
          step.open = false;
          step.classList.remove('mph-step--open');
          return;
        }
        if (!prefersReducedMotion() || !step.open) return;

        config.querySelectorAll('details[data-mph-step]').forEach((other) => {
          if (other === step || !other.open) return;
          other.open = false;
          other.classList.remove('mph-step--open');
        });
      },
      true
    );

    bindAnimatedDetails(config, 'details[data-mph-step]', '.mph-step__body', true);
    bindAnimatedDetails(
      root.querySelector('.main-product-hero__info-accordions'),
      '.main-product-hero__info-accordion',
      '.main-product-hero__info-content',
      false
    );
  };

  const distributeQikifyFields = () => {
    if (!config) return false;
    const host = findTcForm();
    const fields = findTcFields(host);
    if (!fields.length) return false;

    let passedFast = false;
    let placedAny = false;

    // Source order: Frame Size/Color → style; remaining until Fast-Track → prescription; Fast-Track → fast.
    fields.forEach((field) => {
      const label = fieldLabel(field);
      let bucket = classifyQikifyLabel(label, field);
      const alreadyPlaced = Boolean(field.dataset.mphSourced || field.dataset.mphHosted || field.dataset.mphClone);
      const existingClone = !alreadyPlaced && field.id ? config.querySelector(`[data-mph-source-id="${CSS.escape(field.id)}"]`) : null;

      if (existingClone) {
        field.classList.add('mph-field--sourced');
        field.dataset.mphSourced = existingClone.dataset.mphClone;
        existingClone.dataset.mphSourceId = field.id;
        pushCloneToSource(existingClone, field);
        syncChoiceVisuals(existingClone);
        if (bucket === 'fast') passedFast = true;
        placedAny = true;
        return;
      }

      if (alreadyPlaced) {
        if (bucket === 'fast' || field.dataset.mphSourced === 'fast' || field.dataset.mphHosted === 'fast') {
          passedFast = true;
        }
        return;
      }

      try {
        if (bucket === 'fast') {
          if (placeField(field, 'fast')) placedAny = true;
          passedFast = true;
          return;
        }

        if (bucket === 'adapt') {
          field.classList.add('mph-field--sourced', 'mph-field--adapt-source');
          placedAny = true;
          return;
        }

        if (bucket === 'skip') return;
        if (bucket === 'prescription' && passedFast) return;

        if (placeField(field, bucket)) placedAny = true;
      } catch (error) {
        console.warn('[main-product-hero] Qikify field place failed', label, error);
      }
    });

    // Only clip the TEPO shell once every field root is accounted for (sourced/hosted/adapt).
    const pending = findTcFields(host).filter(
      (field) => !field.dataset.mphSourced && !field.dataset.mphHosted && !field.classList.contains('mph-field--adapt-source')
    );
    if (!pending.length) {
      host?.classList.add('mph-tc-source');
      config.classList.add('mph-config--tc-ready');
    }

    hideEmptySlots();
    bindAdaptationSync();
    clearFirstStepDefaults();
    settleRequiredOnlyChoices();
    refreshStepGates();
    return placedAny || !pending.length;
  };

  const visibleSteps = () => {
    if (!config) return [];
    return [...config.querySelectorAll('details[data-mph-step]')].filter(
      (step) => !step.hidden && !step.classList.contains('mph-step--empty')
    );
  };

  const choiceFields = (step) =>
    [...step.querySelectorAll('fieldset, .tcustomizer-field')].filter((field) => {
      const inputs = [...field.querySelectorAll('input[type="radio"], input[type="checkbox"]')];
      return inputs.some((input) => input.closest('fieldset, .tcustomizer-field') === field);
    });

  const fieldChosen = (field) => {
    const inputs = [...field.querySelectorAll('input[type="radio"], input[type="checkbox"]')].filter(
      (input) => input.closest('fieldset, .tcustomizer-field') === field
    );
    const radios = inputs.filter((input) => input.type === 'radio');
    if (radios.length) {
      const names = new Set(radios.map((input) => input.name || input.dataset.mphMirrorName || ''));
      return [...names].every((name) =>
        radios.some((input) => (input.name || input.dataset.mphMirrorName || '') === name && input.checked)
      );
    }
    return inputs.some((input) => input.checked);
  };

  const isRequired = (field) => Boolean(field.querySelector('.tcustomizer-field__heading .tcustomizer-asterisk'));

  // Qikify renders required fields as text, number, select and file controls. The gate has to see all
  // of them, otherwise a step goes green while the app still rejects the add with a generic message.
  const VALUE_CONTROL_SELECTOR =
    'textarea, select, input[type="text"], input[type="number"], input[type="email"], input[type="tel"], input[type="url"], input[type="date"], input[type="file"], input:not([type])';

  const controlEmpty = (el) => (el.type === 'file' ? el.files.length === 0 : !String(el.value || '').trim());

  const textFieldEmpty = (field) => {
    const inputs = controlsOf(field).filter((el) => el.matches(VALUE_CONTROL_SELECTOR));
    return inputs.length > 0 && inputs.every(controlEmpty);
  };

  const missingFields = (step) => [
    ...choiceFields(step).filter((field) => {
      // Optional Qikify radios (Frame Size, Neck Pain, Rx) are not blockers. Required
      // ones (XL Frame Color, Fast-Track) and native Shopify option fieldsets still are.
      if (field.classList.contains('tcustomizer-field') && !isRequired(field)) return false;
      return !fieldChosen(field);
    }),
    ...[...step.querySelectorAll('.tcustomizer-field')].filter((field) => isRequired(field) && textFieldEmpty(field)),
  ];

  const stepIsComplete = (step) => missingFields(step).length === 0;

  let firstStepTouched = false;
  let gateLock = false;

  // A ?variant= in the URL means the shopper already made a choice — a reload, browser back, or a
  // shared link. Clearing step 1 there would contradict the rendered price and block add-to-cart.
  const hasExplicitVariant = () => {
    try {
      return new URLSearchParams(window.location.search).has('variant');
    } catch (error) {
      return false;
    }
  };

  const isMagnificationField = (field) => {
    const name = `${field.dataset.mphNativeOption || ''} ${fieldLabel(field)}`;
    return /magnification/i.test(name);
  };

  // Only wipe Magnification. On EVO 3.5x step 1 is Loupe Color — clearing it leaves Style /
  // Frame Color selected with no matching variant, so the gallery never updates.
  const clearFirstStepDefaults = () => {
    if (firstStepTouched || hasExplicitVariant()) return;
    const step = visibleSteps()[0];
    if (!step) return;

    const targets = [...step.querySelectorAll('fieldset[data-mph-native-option], .tcustomizer-field')].filter(
      (field) => isMagnificationField(field)
    );
    if (!targets.length) return;

    targets.forEach((field) => {
      field.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => {
        input.checked = false;
      });
    });
    const slotName = step.dataset.mphStep;
    root.querySelectorAll('.mph-field--sourced').forEach((source) => {
      if (source.dataset.mphSourced !== slotName) return;
      if (!isMagnificationField(source)) return;
      source.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => {
        input.checked = false;
      });
    });
    syncChoiceVisuals(config);
  };

  const refreshStepGates = ({ advance = false } = {}) => {
    if (!config || gateLock) return;
    const steps = visibleSteps();
    let blocked = false;
    let advanceFrom = -1;

    steps.forEach((step, index) => {
      const locked = blocked;
      const complete = !locked && stepIsComplete(step);
      const wasComplete = step.classList.contains('mph-step--complete');
      step.classList.toggle('mph-step--locked', locked);
      step.classList.toggle('mph-step--complete', complete);
      const summary = step.querySelector('.mph-step__summary');
      if (summary) summary.setAttribute('aria-disabled', locked ? 'true' : 'false');
      if (locked && step.open) settleStep(step, false);
      if (advance && !wasComplete && complete && step.open && steps[index + 1]) advanceFrom = index;
      if (!complete) blocked = true;
    });

    if (advance && advanceFrom >= 0) {
      const next = steps[advanceFrom + 1];
      if (next && !next.classList.contains('mph-step--locked')) {
        gateLock = true;
        collapseDetails(steps[advanceFrom], '.mph-step__body');
        expandDetails(next, '.mph-step__body');
        gateLock = false;
        return;
      }
    }

    const openStep = steps.find((step) => step.open && !step.classList.contains('mph-step--locked'));
    if (!openStep) {
      const first = steps.find((step) => !step.classList.contains('mph-step--locked'));
      if (first) settleStep(first, true);
    }
  };

  const collectVariantItems = () => {
    const items = [];
    root.querySelectorAll('variant-radios fieldset, variant-selects .product-form__input').forEach((field) => {
      const legend = field.querySelector('legend, .form__label, label.form__label');
      const label = normalizeLabel(legend?.textContent);
      if (!label) return;

      let value = '';
      const checked = field.querySelector('input[type="radio"]:checked');
      if (checked) value = checked.value;
      const select = field.querySelector('select');
      if (select) value = select.options[select.selectedIndex]?.textContent?.trim() || select.value;

      if (value) items.push({ label: summaryLabel(label), value });
    });
    return items;
  };

  const collectAppItems = () => {
    const items = [];
    const scopes = [
      ...root.querySelectorAll('[data-mph-qikify-slot] .mph-field--clone, [data-mph-qikify-slot] .mph-field--hosted'),
      ...root.querySelectorAll('.mph-field--sourced'),
    ];

    const seen = new Set();
    scopes.forEach((field) => {
      if (field.classList.contains('mph-field--sourced') && field.dataset.mphSourced) return;
      const label = fieldLabel(field);
      if (!label || /adaptation|single checkbox/i.test(label)) return;
      const key = label.toLowerCase();
      if (seen.has(key)) return;

      let value = '';
      const checked = field.querySelector('.tcustomizer-field__input input[type="radio"]:checked, .tcustomizer-field__input input[type="checkbox"]:checked');
      const select = field.querySelector('.tcustomizer-field__input select');
      const text = field.querySelector('input:not([type]), input[type="text"], textarea');
      if (checked) {
        value = normalizeLabel(checked.value) || 'Yes';
      } else if (select && select.value) {
        const selected = select.options[select.selectedIndex];
        value = normalizeLabel(selected?.textContent || select.value);
        if (!value || /^select/i.test(value)) value = '';
      } else if (text) {
        value = (text.value || '').trim();
      }
      if (!value) return;
      seen.add(key);
      items.push({ label: summaryLabel(label), value });
    });

    return items;
  };

  const renderChecklist = () => {
    if (!checklist) return;
    const items = [...collectVariantItems(), ...collectAppItems()]
      .map((item, index) => ({ ...item, index }))
      .sort((a, b) => summaryRank(a.label) - summaryRank(b.label) || a.index - b.index);
    if (!items.length) return;
    checklist.style.setProperty('--mph-check-rows', String(Math.ceil(items.length / 2)));

    checklist.innerHTML = items
      .map(
        (item) => `
      <li class="main-product-hero__check-item">
        <span class="main-product-hero__check-icon" aria-hidden="true">${checkIcon}</span>
        <span class="main-product-hero__check-text">
          <strong>${escapeHtml(item.label).toUpperCase()}:</strong>
          <span data-mph-check-value>${escapeHtml(item.value)}</span>
        </span>
      </li>`
      )
      .join('');

    if (totalEl) totalEl.textContent = readPriceText();
  };

  // Add to cart stays enabled (Figma 450:14836); an incomplete build is explained on submit instead.
  const showGuard = (message) => {
    if (!guardEl) return;
    guardEl.textContent = message;
    guardEl.hidden = !message;
  };

  const syncAdaptGate = () => {
    root.classList.toggle('mph-adapt-confirmed', Boolean(adaptInput?.checked));
    if (adaptInput?.checked && guardEl?.dataset.mphGuardReason === 'adapt') {
      showGuard('');
      delete guardEl.dataset.mphGuardReason;
    }
    adaptWrap?.classList.toggle('main-product-hero__adapt--invalid', false);
  };

  const stepTitle = (step) => step.querySelector('.mph-step__title')?.textContent?.trim() || '';

  const openStep = (step) => {
    if (!step) return;
    visibleSteps().forEach((other) => {
      if (other !== step && other.open) settleStep(other, false);
    });
    settleStep(step, true);
    step.querySelector('.mph-step__summary')?.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' });
  };

  const firstBlocker = () => {
    const step = visibleSteps().find((candidate) => !stepIsComplete(candidate));
    if (step) {
      const names = missingFields(step)
        .map((field) => styleFor(fieldLabel(field))?.label || fieldLabel(field))
        .filter(Boolean);
      const detail = names.length ? `: ${[...new Set(names)].join(', ')}` : '';
      return { reason: 'step', step, message: `Please complete “${stepTitle(step)}”${detail}.` };
    }
    if (adaptInput && adaptInput.getAttribute('aria-required') === 'true' && !adaptInput.checked) {
      return {
        reason: 'adapt',
        step: adaptWrap?.closest('[data-mph-step]') || null,
        message: 'Please confirm the adaptation acknowledgement before adding to cart.',
      };
    }
    return null;
  };

  // Qikify/TEPO replaces the native submit with its own #tcustomizer-add (type=button, AJAX add), so the guard
  // runs on click in the capture phase (before the app's handler) as well as on native form submit.
  const ATC_SELECTOR = '#tcustomizer-add, button[name="add"], .product-form__sticky-submit';

  const guardAddToCart = (event) => {
    if (event.type === 'submit') {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;
    } else {
      const button = event.target.closest?.(ATC_SELECTOR);
      if (!button || !root.contains(button) || button.disabled) return;
    }
    flushClonesToSources();
    const blocker = firstBlocker();
    if (!blocker) {
      showGuard('');
      clearAppErrors();
      // The app validates asynchronously and can render its error on any of these ticks.
      [600, 1200, 2200].forEach((delay) => window.setTimeout(mirrorAppError, delay));
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (guardEl) guardEl.dataset.mphGuardReason = blocker.reason;
    showGuard(blocker.message);
    if (blocker.step) openStep(blocker.step);
    if (blocker.reason === 'adapt') {
      adaptWrap?.classList.add('main-product-hero__adapt--invalid');
      adaptInput.focus({ preventScroll: Boolean(blocker.step) });
    } else {
      blocker.step?.querySelector('input:not([type="hidden"]):not([disabled]), select, textarea')?.focus({ preventScroll: true });
    }
  };

  const APP_ERROR_CLASS = 'mph-field--app-error';

  const isFieldVisible = (el) => Boolean(el && (el.offsetParent || el.getClientRects().length));

  const clearAppErrors = () => {
    root.querySelectorAll(`.${APP_ERROR_CLASS}`).forEach((node) => node.classList.remove(APP_ERROR_CLASS));
  };

  // The app marks the field it rejected, but that node is often the hidden source we cloned into a
  // step, so the shopper sees a message with nothing highlighted. Resolve the visible twin instead.
  const visibleTwinOf = (field) => {
    if (!field) return null;
    if (isFieldVisible(field)) return field;
    // The adaptation acknowledgement has no app-rendered twin: the theme renders its own checkbox
    // and syncs the app field in the background, so send the shopper there instead.
    if (field.classList.contains('mph-field--adapt-source') && isFieldVisible(adaptWrap)) return adaptWrap;
    if (field.id && config) {
      const bySource = config.querySelector(`[data-mph-source-id="${CSS.escape(field.id)}"]`);
      if (isFieldVisible(bySource)) return bySource;
    }
    const name = fieldLabel(field);
    if (!name || !config) return null;
    return (
      [...config.querySelectorAll('.tcustomizer-field')].find(
        (candidate) => isFieldVisible(candidate) && fieldLabel(candidate) === name
      ) || null
    );
  };

  const mirrorAppError = () => {
    const errorNode = [...root.querySelectorAll('.tcustomizer-error')].find((node) => node.textContent.trim());
    if (!errorNode) return;
    const message = errorNode.textContent.trim();
    const target = visibleTwinOf(errorNode.closest('.tcustomizer-field'));
    clearAppErrors();
    if (!target) {
      showGuard(message);
      return;
    }
    target.classList.add(APP_ERROR_CLASS);
    const name = fieldLabel(target);
    showGuard(name ? `${message} Please complete \u201C${name}\u201D.` : message);
    const step = target.closest('[data-mph-step]');
    if (step) openStep(step);
    target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' });
    target
      .querySelector('input:not([type="hidden"]):not([disabled]), select, textarea')
      ?.focus({ preventScroll: true });
  };

  root.addEventListener('click', guardAddToCart, true);
  root.addEventListener('submit', guardAddToCart, true);
  // Once the shopper edits anything, drop the stale app-error highlight.
  root.addEventListener('input', clearAppErrors);
  root.addEventListener('change', clearAppErrors);

  // The delivery app repeats the theme's shipping heading; keep only its date line under the theme heading.
  const dedupeDeliveryHeading = () => {
    const delivery = root.querySelector('[data-mph-delivery]');
    if (!delivery || !root.querySelector('.main-product-hero__shipping-heading')) return;
    delivery.querySelectorAll('.msg__container p').forEach((line) => {
      if (/free shipping/i.test(line.textContent || '') && !/order within|receive/i.test(line.textContent || '')) {
        line.classList.add('mph-delivery__duplicate');
      }
    });
  };

  const findAdaptationSource = () => {
    const fields = [
      ...root.querySelectorAll('.tcustomizer-field, [class*="tcustomizer-field"], .mph-field--adapt-source'),
    ];
    const match = fields.find((node) =>
      /adaptation period|adaptation|single checkbox/i.test(fieldLabel(node) || node.textContent || '')
    );
    if (!match) return null;
    const field = match.closest('.tcustomizer-field, [class*="tcustomizer-field"]') || match;
    const checkbox = field.querySelector('input[type="checkbox"]');
    return checkbox ? { field, checkbox } : null;
  };

  // Keep Figma theme checkbox as the visible UI; sync any Qikify adaptation field in the background.
  const bindAdaptationSync = () => {
    if (!adaptInput) return false;
    const source = findAdaptationSource();
    if (!source) return false;

    source.field.classList.add('mph-field--sourced', 'mph-field--adapt-source');

    const pushToSource = () => {
      const current = findAdaptationSource();
      if (!current || current.checkbox.checked === adaptInput.checked || current.checkbox.disabled) return;
      current.checkbox.click();
    };

    if (!adaptBound) {
      adaptInput.addEventListener('change', () => {
        pushToSource();
        syncAdaptGate();
      });
      adaptInput.checked = source.checkbox.checked;
      adaptBound = true;
    } else {
      pushToSource();
    }

    if (!adaptSourceInputs.has(source.checkbox)) {
      source.checkbox.addEventListener('change', () => {
        const current = findAdaptationSource();
        if (current?.checkbox !== source.checkbox) return;
        adaptInput.checked = source.checkbox.checked;
        syncAdaptGate();
      });
      adaptSourceInputs.add(source.checkbox);
    }

    syncAdaptGate();
    return true;
  };

  const boot = () => {
    atcButtons.forEach((btn) => {
      // Only freeze true sold-out — adapt gate also disables ATC temporarily.
      if (btn.disabled && /sold out/i.test(btn.textContent || '')) {
        btn.dataset.mphSoldOut = 'true';
      }
    });

    root.querySelectorAll('.main-product-hero__check-icon').forEach((el) => {
      if (!el.innerHTML.trim()) el.innerHTML = checkIcon;
    });

    distributeQikifyFields();
    hideEmptySlots();
    clearFirstStepDefaults();
    refreshStepGates();
    initExclusiveAccordion();
    bindAdaptationSync();
    renderChecklist();
    syncAdaptGate();
    dedupeDeliveryHeading();

    const delivery = root.querySelector('[data-mph-delivery]');
    if (delivery) new MutationObserver(dedupeDeliveryHeading).observe(delivery, { childList: true, subtree: true });
  };

  config?.addEventListener(
    'change',
    (event) => {
      if (!event.isTrusted) return;
      firstStepTouched = true;
      refreshStepGates({ advance: true });
      if (guardEl && !guardEl.hidden) {
        const blocker = firstBlocker();
        if (blocker) {
          guardEl.dataset.mphGuardReason = blocker.reason;
          showGuard(blocker.message);
        } else {
          delete guardEl.dataset.mphGuardReason;
          showGuard('');
        }
      }
    },
    true
  );

  root.addEventListener('change', (event) => {
    if (event.target?.matches?.('[data-mph-adapt]')) {
      syncAdaptGate();
      return;
    }
    renderChecklist();
    syncAdaptGate();
  });

  if (priceRoot) {
    const priceObserver = new MutationObserver(() => {
      if (totalEl) totalEl.textContent = readPriceText();
    });
    priceObserver.observe(priceRoot, { childList: true, subtree: true, characterData: true });
  }

  // Observe Qikify inside the config host — not the first .shopify-app-block on the page (Loox).
  const appHost =
    config?.querySelector('[id^="tcustomizer-form-container"], .shopify-app-block, .tcustomizer-customization-form') ||
    root.querySelector('[id^="tcustomizer-form-container"]');
  const tcHost = appHost || config;
  if (tcHost) {
    let redistributeTimer = 0;
    const scheduleRedistribute = (mutations) => {
      const addedTc = mutations.some((mutation) =>
        [...mutation.addedNodes].some((node) => {
          if (node.nodeType !== 1) return false;
          return (
            node.matches?.('.tcustomizer-field, .tcustomizer-customization-form, [id^="tcustomizer-form-container"]') ||
            Boolean(node.querySelector?.('.tcustomizer-field, .tcustomizer-customization-form'))
          );
        })
      );
      if (!addedTc) return;
      window.clearTimeout(redistributeTimer);
      redistributeTimer = window.setTimeout(() => {
        distributeQikifyFields();
        bindAdaptationSync();
        renderChecklist();
      }, 120);
    };
    // TEPO injects its fields after load. _TC.manualOptions is the field schema
    // (labels, types, preselects) and arrives with that script, but the inputs
    // that submit line-item properties only exist once the widget DOM is in.
    const appObserver = new MutationObserver(scheduleRedistribute);
    appObserver.observe(tcHost, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
